import { getSearchParam, removeSearchParam } from "./document";
import { updateJWT } from "./auth/jwt";
import { exchangeTemporaryJWT } from "../apiLoader/auth";
import { getFingerprint } from "../public/lib/helpers/fingerprint";
import { navigateToPath } from "../routing";
import PATHS from "../constants/routePaths";
import { trackSiteVisit } from "../apiLoader/track";
import { sessionStore, updateSession } from "../stores/session";
import { decodeJWT } from "../public/lib/helpers/jwt";
import { get } from "svelte/store";
import { settingsStore } from "../stores/settings";

const processTemporaryJWT = async (tempJwt: string) => {
  const turnstileTokenData = get(sessionStore).turnstileTokenData;
  const requiresCaptcha = get(settingsStore).requiresCaptcha;
  if (requiresCaptcha && !turnstileTokenData) {
    throw new Error("No turnstile token found but temporary JWT exchange requires captcha.");
  }
  updateJWT((await exchangeTemporaryJWT(getFingerprint(), tempJwt, turnstileTokenData?.token)).jwt);
};

export const handleTempJWTIfPresent = async () => {
  const jwt = getSearchParam("jwt");

  if (jwt) {
    try {
      const jwtData = decodeJWT(jwt);
      const nowInSeconds = Date.now() / 1000;
      if (jwtData.exp && jwtData.exp < nowInSeconds) {
        removeSearchParam("jwt");
        updateSession({ isExpired: true });
      } else if (jwtData.is_temp) {
        await processTemporaryJWT(jwt);
        trackSiteVisit();
        removeSearchParam("jwt");
      }
    } catch (e) {
      console.error("Error validating identifier", e);
      return navigateToPath(PATHS.AUTHENTICATION_ERROR);
    }
  }
};
